import { find, filter, cloneDeep, reject, mapValues } from 'lodash';
import { redirect } from 'redux-first-router'
import { beginTask, endTask } from 'redux-nprogress';
import { selectParams } from '../../../../store/reducers/location.selectors';
import {
  selectDefaultFormula,
  selectCustomFormulas,
  selectFormulasForDropdown,
  selectFormula,
  loadFormulas,
  loadFormulaOptions,
} from '../../../../store/reducers/formula';
import {
  getTracking,
  addTracking,
  changeTracking,
  deleteTracking,
  deleteLeagueTracking,
} from '../../../../store/actions/tracking.actions';
import routes from '../../../routes.global';
import { GO_LOGIN } from '../../../../store/actions/auth.types';
import { RENEW_SUBSCRIPTION_VIEW } from '../../PaymentInformation/module';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'customLeague';
export const selectCustomState = state => state[STORE_KEY];
export const selectTrackings = state => selectCustomState(state).trackings;
export const selectTrackedPlayerCountByFormula = (state, formulaId) => {
  const formula = selectFormula(state, formulaId);
  const trackings = selectTrackings(state);

  return trackings.reduce((sum, tracking) =>
  sum + (tracking.formulas.find(({ formula_id: id }) => id === formula.id) ? 1 : 0)
  , 0);
};
// TODO: Figure out what the heck happened here...
// Some random ass bug with webpack caused this to break the entire app????
// It doesn't even get used on the main route, yet out of the blue it just broke everything
// For now I just built a non memoized version
// export const selectTrackedPlayerCountByFormula = createSelector(
//   [selectFormula, selectTrackings],
//   (formula, trackings) => trackings.reduce((sum, tracking) =>
//     sum + (tracking.formulas.find(({ formula_id: id }) => id === formula.id) ? 1 : 0)
//   , 0),
// );

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};

const customLeagueValueCount = 66;
var baseValues = {};
for (var i = 1; i <= customLeagueValueCount; i += 1) {
  baseValues[i] = {};
}

const initialState = {
  hasLoaded: null,
  error: null,
  originalLeague: null,
  currentFormula: null,
  blankFormula: {
    name: '',
    combine: 0,
    use_idp: 0,
    use_st: 0,
    rb_wr: 0,
    wr_te: 0,
    values: mapValues(baseValues, () => ({
      points: 0,
      units: 0,
    })),
  },
  currentTracking: null,
  originalTracking: null,
  trackingData: null,
  shouldDuplicateTracking: false,

  // TODO: Need to move these out to a globally stored piece of state
  // such as models: { } such that these are able to be accessed throughout
  // the app more easily, and not be confused with the specific functionality
  // of the custom league reducer/actions
  trackings: [],
};

export const customReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default customReducer;

// ------------------------------------
// Change League name error status
// ------------------------------------
export const CHANGE_LEAGUE_NAME_ERROR = `${STORE_KEY}/CHANGE_LEAGUE_NAME_ERROR`;
export const changeLeagueNameErrorAction = (hasError) => ({
  type: CHANGE_LEAGUE_NAME_ERROR,
  payload: { hasError },
});
actions[CHANGE_LEAGUE_NAME_ERROR] = (state, { payload: { hasError } }) => ({ ...state,
  leagueNameError: hasError,
});
// expects a boolean value setting the error status (true = error, false = no error)
export const changeLeagueNameError = (error) => async (dispatch, getState) => {
  dispatch(changeLeagueNameErrorAction(error));
};

// ------------------------------------
// Store unmodified Player League data
// ------------------------------------
export const CHANGE_ORIGINAL_LEAGUE = `${STORE_KEY}/CHANGE_ORIGINAL_LEAGUE`;
export const changeOriginalLeagueAction = (originalLeague) => ({
  type: CHANGE_ORIGINAL_LEAGUE,
  payload: { originalLeague },
});
actions[CHANGE_ORIGINAL_LEAGUE] = (state, { payload: { originalLeague } }) => ({ ...state,
  originalLeague,
});
export const changeOriginalLeague = league => async (dispatch, getState) => {
  dispatch(changeOriginalLeagueAction(league));
};

// ------------------------------------
// Store unmodified Player Tracking data
// ------------------------------------
export const CHANGE_ORIGINAL_TRACKING = `${STORE_KEY}/CHANGE_ORIGINAL_TRACKING`;
export const changeOriginalTrackingAction = (originalTracking) => ({
  type: CHANGE_ORIGINAL_TRACKING,
  payload: { originalTracking },
});
actions[CHANGE_ORIGINAL_TRACKING] = (state, { payload: { originalTracking } }) => ({ ...state,
  originalTracking: originalTracking,
});
export const changeOriginalTracking = tracking => async (dispatch, getState) => {
  dispatch(changeOriginalTrackingAction(tracking));
};

// ------------------------------------
// Store updated Player Tracking data
// ------------------------------------
export const CHANGE_UPDATED_TRACKING = `${STORE_KEY}/CHANGE_UPDATED_TRACKING`;
export const changeUpdatedTrackingAction = (updatedTracking) => ({
  type: CHANGE_UPDATED_TRACKING,
  payload: { updatedTracking },
});
actions[CHANGE_UPDATED_TRACKING] = (state, { payload: { updatedTracking } }) => ({ ...state,
  updatedTracking,
});
export const changeUpdatedTracking = tracking => async (dispatch, getState) => {
  dispatch(changeUpdatedTrackingAction(tracking));
};

// ------------------------------------
// Update an individual value
// ------------------------------------
export const CHANGE_VALUE = `${STORE_KEY}/CHANGE_VALUE`;
export const changeValue = (id, key, value) => ({
  type: CHANGE_VALUE,
  payload: { id, key, value },
});
actions[CHANGE_VALUE] = (state, { payload }) => ({ ...state,
  currentFormula: { ...state.currentFormula,
    values: { ...state.currentFormula.values,
      [payload.id]: { ...state.currentFormula.values[payload.id],
        [payload.key]: Number(payload.value),
      },
    },
  },
});

// ------------------------------------
// Name the league
// ------------------------------------
export const CHANGE_FORMULA_NAME = `${STORE_KEY}/CHANGE_FORMULA_NAME`;
export const changeFormulaName = name => ({
  type: CHANGE_FORMULA_NAME,
  payload: { name },
});
actions[CHANGE_FORMULA_NAME] = (state, { payload }) => ({ ...state,
  currentFormula: { ...state.currentFormula,
    name: payload.name,
  },
});

// ------------------------------------
// Prepares the tabbing index
// ------------------------------------
export const PREPARE_TABBING_INDEX = `${STORE_KEY}/PREPARE_TABBING_INDEX`;
export const prepareTabbingIndexAction = (tabbingIndex) => ({
  type: PREPARE_TABBING_INDEX,
  payload: { tabbingIndex },
});
actions[PREPARE_TABBING_INDEX] = (state, { payload: { tabbingIndex } }) => ({ ...state,
  tabbingIndex,
});
export const prepareTabbingIndex = (stats) => async (dispatch, getState) => {

  const categories = ['QB','RB','WR','TE','DF','DL','LB','DB','PK','ST']; // in order of appearance on page

  const tabbingIndex = [];
  if (categories.length) {
    categories.forEach(category => {
      if (stats[category] && stats[category].length) {
        stats[category].forEach(stat => {
          tabbingIndex.push(`${stat.id}points`);
          tabbingIndex.push(`${stat.id}units`);
        });
      }
    });
  }

  dispatch(prepareTabbingIndexAction(tabbingIndex));
};

// ------------------------------------
// Sets the player tracking object
// ------------------------------------
export const LOAD_LEAGUE_TRACKING = `${STORE_KEY}/LOAD_LEAGUE_TRACKING`;
export const loadLeagueTrackingAction = (trackingData) => ({
  type: LOAD_LEAGUE_TRACKING,
  payload: { trackingData },
});
actions[LOAD_LEAGUE_TRACKING] = (state, { payload: { trackingData } }) => ({ ...state,
  trackingData: trackingData,
});
export const loadLeagueTracking = (trackingData) => async (dispatch, getState) => {
  dispatch(loadLeagueTrackingAction(trackingData));
};

// ------------------------------------
// Sets shouldDuplicateTracking
// ------------------------------------
export const TOGGLE_SHOULD_DUPLICATE_TRACKING = `${STORE_KEY}/TOGGLE_SHOULD_DUPLICATE_TRACKING`;
export const setShouldDuplicateTrackingAction = (shouldDuplicateTracking) => ({
  type: TOGGLE_SHOULD_DUPLICATE_TRACKING,
  payload: { shouldDuplicateTracking },
});
actions[TOGGLE_SHOULD_DUPLICATE_TRACKING] = (state, { payload: { shouldDuplicateTracking } }) => ({ ...state,
  shouldDuplicateTracking,
});
export const setShouldDuplicateTracking = (shouldDuplicateTracking) => async (dispatch, getState) => {
  dispatch(setShouldDuplicateTrackingAction(shouldDuplicateTracking));
};

// ------------------------------------
// Selects a single League's tracking
// ------------------------------------
export const FETCH_LEAGUE_TRACKING = `${STORE_KEY}/FETCH_LEAGUE_TRACKING`;
export const fetchLeagueTrackingAction = (trackingData, leagueId) => ({
  type: FETCH_LEAGUE_TRACKING,
  payload: { trackingData, leagueId },
});
actions[FETCH_LEAGUE_TRACKING] = (state, { payload: { trackingData, leagueId } }) => ({ ...state,
  currentTracking: filter(trackingData, (player) =>
    filter(player.formulas, formula => formula.formula_id === leagueId).length ? true : false),
});
export const fetchLeagueTracking = (trackingData, leagueId) => async (dispatch, getState) => {
  dispatch(fetchLeagueTrackingAction(trackingData, leagueId));
};

// ------------------------------------
// Load the default league
// ------------------------------------
export const LOAD_DEFAULT_LEAGUE = `${STORE_KEY}/LOAD_DEFAULT_LEAGUE`;
export const loadDefaultLeagueAction = defaultLeague => ({
  type: LOAD_DEFAULT_LEAGUE,
  payload: { defaultLeague },
});
actions[LOAD_DEFAULT_LEAGUE] = (state, { payload }) => ({ ...state,
  currentFormula: { ...payload.defaultLeague,
    name: '',
  }
});
export const loadDefaultLeague = () => async (dispatch, getState) => {
  const defaultLeague = selectFormula(getState(), 1);
  dispatch(loadDefaultLeagueAction(defaultLeague));
};

// ------------------------------------
// Duplicate an existing League
// ------------------------------------
export const DUPLICATE_LEAGUE = `${STORE_KEY}/DUPLICATE_LEAGUE`;
export const duplicateLeagueAction = (baseFormula, name) => ({
  type: DUPLICATE_LEAGUE,
  payload: { baseFormula, name },
});
actions[DUPLICATE_LEAGUE] = (state, { payload: { name, baseFormula } }) => ({ ...state,
  currentFormula: {
    name: name || (state.currentFormula && state.currentFormula.name) || '',
    use_st: baseFormula.use_st,
    use_idp: baseFormula.use_idp,
    combine: baseFormula.combine,
    rb_wr: baseFormula.rb_wr,
    wr_te: baseFormula.wr_te,
    values: cloneDeep(baseFormula.values),
  },
});
export const duplicateLeague = (id, name) => async (dispatch, getState) => {
  const baseFormula = id ? selectFormula(getState(), id) : getState().blankFormula;
  dispatch(duplicateLeagueAction(baseFormula, name || baseFormula.name));
};

// ------------------------------------
// Restore a League
// ------------------------------------
export const RESTORE_LEAGUE = `${STORE_KEY}/RESTORE_LEAGUE`;
export const restoreLeagueAction = (newFormula) => ({
  type: RESTORE_LEAGUE,
  payload: { newFormula },
});
actions[RESTORE_LEAGUE] = (state, { payload: { newFormula } }) => ({ ...state,
  currentFormula: {
    name: newFormula.name,
    use_st: newFormula.use_st,
    use_idp: newFormula.use_idp,
    combine: newFormula.combine,
    rb_wr: newFormula.rb_wr,
    wr_te: newFormula.wr_te,
    values: cloneDeep(newFormula.values),
  },
});
export const restoreLeague = (newFormula) => async (dispatch, getState) => {
  dispatch(restoreLeagueAction(newFormula));
};

// ------------------------------------
// Restore a League's Tracking
// ------------------------------------
export const RESTORE_TRACKING = `${STORE_KEY}/RESTORE_TRACKING`;
export const restoreTrackingAction = (newTracking) => ({
  type: RESTORE_TRACKING,
  payload: { newTracking },
});
actions[RESTORE_TRACKING] = (state, { payload: { newTracking } }) => ({ ...state,
  currentTracking: newTracking,
});
export const restoreTracking = (newTracking) => async (dispatch, getState) => {
  dispatch(restoreTrackingAction(newTracking));
};

// ------------------------------------
// Create a new League
// ------------------------------------
export const CREATE_CUSTOM_LEAGUE = `${STORE_KEY}/CREATE_CUSTOM_LEAGUE`;
export const CREATE_CUSTOM_LEAGUE_SUCCESS = `${STORE_KEY}/CREATE_CUSTOM_LEAGUE_SUCCESS`;
export const CREATE_CUSTOM_LEAGUE_ERROR = `${STORE_KEY}/CREATE_CUSTOM_LEAGUE_ERROR`;

export const createCustomLeagueAction = () => ({
  type: CREATE_CUSTOM_LEAGUE,
  payload: { },
});
export const createCustomLeagueSuccessAction = () => ({
  type: CREATE_CUSTOM_LEAGUE_SUCCESS,
  payload: { },
});
export const createCustomLeagueErrorAction = error => ({
  type: CREATE_CUSTOM_LEAGUE_ERROR,
  payload: { error },
});

actions[CREATE_CUSTOM_LEAGUE] = state => ({ ...state,
});
actions[CREATE_CUSTOM_LEAGUE_SUCCESS] = state => ({ ...state,
  hasLoaded: true,
});
actions[CREATE_CUSTOM_LEAGUE_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const createCustomLeague = () => async (dispatch, getState) => {
  try {
    dispatch(beginTask());
    dispatch(createCustomLeagueAction());

    saveFormula(state.currentFormula);

    dispatch(createCustomLeagueSuccessAction());
  } catch (error) {
    console.error(error);
    dispatch(createCustomLeagueErrorAction(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// Update a player's tracking
// ------------------------------------
export const SAVE_PLAYER_TRACKING = `${STORE_KEY}/SAVE_PLAYER_TRACKING`;
export const SAVE_PLAYER_TRACKING_SUCCESS = `${STORE_KEY}/SAVE_PLAYER_TRACKING_SUCCESS`;
export const SAVE_PLAYER_TRACKING_ERROR = `${STORE_KEY}/SAVE_PLAYER_TRACKING_ERROR`;

export const savePlayerTrackingAction = () => ({
  type: SAVE_PLAYER_TRACKING,
  payload: { },
});
export const savePlayerTrackingSuccessAction = () => ({
  type: SAVE_PLAYER_TRACKING_SUCCESS,
  payload: { },
});
export const savePlayerTrackingErrorAction = error => ({
  type: SAVE_PLAYER_TRACKING_ERROR,
  payload: { error },
});

actions[SAVE_PLAYER_TRACKING] = state => ({ ...state, });
actions[SAVE_PLAYER_TRACKING_SUCCESS] = state => ({ ...state, });
actions[SAVE_PLAYER_TRACKING_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
});

export const savePlayerTracking = (updatedTracking = []) => async (dispatch, getState) => {
  try {
    dispatch(beginTask());
    dispatch(savePlayerTrackingAction());

    const state = getState();
    const { originalTracking, leagueId } = state.customLeague;

    const trackingToDelete = [];
    if (originalTracking && originalTracking.length) {
      originalTracking.forEach(({ player_id, formulas = [] }) => {
        trackingToDelete.push({
          player_id,
          formula_ids: [leagueId],
        });
      });
    }

    await Promise.all([
      originalPlayers.length && dispatch(deleteTracking(trackingToDelete)),
      updatedTracking.length && dispatch(changeTracking(updatedTracking)),
    ]);

    dispatch(savePlayerTrackingSuccessAction());
  } catch (error) {
    console.error(error);
    dispatch(savePlayerTrackingErrorAction(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// Toggles
// ------------------------------------

export const TOGGLE_WR_TO_TE = `${STORE_KEY}/TOGGLE_WR_TO_TE`;
export const toggleWRtoTE = () => ({
  type: TOGGLE_WR_TO_TE,
  payload: { },
});
actions[TOGGLE_WR_TO_TE] = state => ({ ...state,
  currentFormula: { ...state.currentFormula,
    wr_te: !state.currentFormula.wr_te ? 1 : 0,
  },
});

export const TOGGLE_RB_TO_WR = `${STORE_KEY}/TOGGLE_RB_TO_WR`;
export const toggleRBtoWR = () => ({
  type: TOGGLE_RB_TO_WR,
  payload: { },
});
actions[TOGGLE_RB_TO_WR] = state => ({ ...state,
  currentFormula: { ...state.currentFormula,
    rb_wr: !state.currentFormula.rb_wr ? 1 : 0,
  },
});

export const TOGGLE_IDP = `${STORE_KEY}/TOGGLE_IDP`;
export const toggleIdp = () => ({
  type: TOGGLE_IDP,
  payload: { },
});
actions[TOGGLE_IDP] = state => ({ ...state,
  currentFormula: { ...state.currentFormula,
    use_idp: !state.currentFormula.use_idp ? 1 : 0,
  },
});

export const TOGGLE_COMBINE = `${STORE_KEY}/TOGGLE_COMBINE`;
export const toggleCombine = () => ({
  type: TOGGLE_COMBINE,
  payload: { },
});
actions[TOGGLE_COMBINE] = state => ({ ...state,
  currentFormula: { ...state.currentFormula,
    combine: !state.currentFormula.combine ? 1 : 0,
  },
});

export const TOGGLE_ST = `${STORE_KEY}/TOGGLE_ST`;
export const toggleSt = () => ({
  type: TOGGLE_ST,
  payload: { },
});
actions[TOGGLE_ST] = state => ({ ...state,
  currentFormula: { ...state.currentFormula,
    use_st: !state.currentFormula.use_st ? 1 : 0,
  },
});

// ------------------------------------
// Initial Fetch of Custom League Data
// ------------------------------------
export const CUSTOM_VIEW_DATA_REQUEST = `${STORE_KEY}/CUSTOM_VIEW_DATA_REQUEST`;
export const CUSTOM_VIEW_DATA_SUCCESS = `${STORE_KEY}/CUSTOM_VIEW_DATA_SUCCESS`;
export const CUSTOM_VIEW_DATA_ERROR = `${STORE_KEY}/CUSTOM_VIEW_DATA_ERROR`;

export const customViewDataRequest = () => ({
  type: CUSTOM_VIEW_DATA_REQUEST,
  payload: { },
});
export const customViewDataSuccess = tracking => ({
  type: CUSTOM_VIEW_DATA_SUCCESS,
  payload: { tracking },
});
export const customViewDataError = error => ({
  type: CUSTOM_VIEW_DATA_ERROR,
  payload: { error },
});

actions[CUSTOM_VIEW_DATA_REQUEST] = state => ({ ...state,
});
actions[CUSTOM_VIEW_DATA_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  trackings: payload.tracking,
});
actions[CUSTOM_VIEW_DATA_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadCustomLeagueData = () => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(customViewDataRequest());
    const [{ tracking }] = await Promise.all([
      api.tracking.getAll(),
      dispatch(loadFormulas),
      dispatch(getTracking),
    ]);

    dispatch(customViewDataSuccess(tracking));
  } catch (error) {
    dispatch(customViewDataError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// Initial Fetch of League Create Data
// ------------------------------------
export const CREATE_VIEW_DATA_REQUEST = `${STORE_KEY}/CREATE_VIEW_DATA_REQUEST`;
export const CREATE_VIEW_DATA_SUCCESS = `${STORE_KEY}/CREATE_VIEW_DATA_SUCCESS`;
export const CREATE_VIEW_DATA_ERROR = `${STORE_KEY}/CREATE_VIEW_DATA_ERROR`;

export const createViewDataRequest = () => ({
  type: CREATE_VIEW_DATA_REQUEST,
  payload: { },
});
export const createViewDataSuccess = () => ({
  type: CREATE_VIEW_DATA_SUCCESS,
  payload: { },
});
export const createViewDataError = error => ({
  type: CREATE_VIEW_DATA_ERROR,
  payload: { error },
});

actions[CREATE_VIEW_DATA_REQUEST] = state => ({ ...state,
});
actions[CREATE_VIEW_DATA_SUCCESS] = state => ({ ...state,
  hasLoaded: true,
});
actions[CREATE_VIEW_DATA_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadCreateCustomLeagueData = () => async (dispatch, getState) => {
  try {
    dispatch(beginTask());
    dispatch(createViewDataRequest());
    await Promise.all([
      dispatch(loadFormulaOptions),
      dispatch(loadFormulas),
      dispatch(getTracking),
    ]);

    dispatch(prepareTabbingIndex(getState().formulas.options));

    dispatch(loadDefaultLeague());
    dispatch(createViewDataSuccess());
  } catch (error) {
    console.error(error);
    dispatch(createViewDataError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// Fetch of League Edit Data
// ------------------------------------
export const EDIT_VIEW_DATA_REQUEST = `${STORE_KEY}/EDIT_VIEW_DATA_REQUEST`;
export const EDIT_VIEW_DATA_SUCCESS = `${STORE_KEY}/EDIT_VIEW_DATA_SUCCESS`;
export const EDIT_VIEW_DATA_ERROR = `${STORE_KEY}/EDIT_VIEW_DATA_ERROR`;

export const editViewDataRequest = () => ({
  type: EDIT_VIEW_DATA_REQUEST,
  payload: { },
});
export const editViewDataSuccess = ({ tracking, id }) => ({
  type: EDIT_VIEW_DATA_SUCCESS,
  payload: { tracking, id },
});
export const editViewDataError = error => ({
  type: EDIT_VIEW_DATA_ERROR,
  payload: { error },
});

actions[EDIT_VIEW_DATA_REQUEST] = state => ({ ...state,
});
actions[EDIT_VIEW_DATA_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  trackings: payload.tracking,
  leagueId: payload.id,
});
actions[EDIT_VIEW_DATA_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadEditCustomLeagueData = () => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(editViewDataRequest());
    const [{ tracking }] = await Promise.all([
      api.tracking.getAll(),
      dispatch(loadFormulaOptions),
      dispatch(loadFormulas),
      dispatch(getTracking),
    ]);

    const state = getState();
    const { id } = selectParams(state);

    dispatch(prepareTabbingIndex(state.formulas.options));
    dispatch(fetchLeagueTracking(tracking, id));
    dispatch(duplicateLeague(id));
    dispatch(changeOriginalLeagueAction(getState().currentFormula));

    dispatch(editViewDataSuccess({ tracking, id }));
  } catch (error) {
    console.error(error);
    dispatch(editViewDataError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// Fetch of League Duplicate Data
// ------------------------------------
export const DUPLICATE_VIEW_DATA_REQUEST = `${STORE_KEY}/DUPLICATE_VIEW_DATA_REQUEST`;
export const DUPLICATE_VIEW_DATA_SUCCESS = `${STORE_KEY}/DUPLICATE_VIEW_DATA_SUCCESS`;
export const DUPLICATE_VIEW_DATA_ERROR = `${STORE_KEY}/DUPLICATE_VIEW_DATA_ERROR`;

export const duplicateViewDataRequest = () => ({
  type: DUPLICATE_VIEW_DATA_REQUEST,
  payload: { },
});
export const duplicateViewDataSuccess = ({ tracking, id }) => ({
  type: DUPLICATE_VIEW_DATA_SUCCESS,
  payload: { tracking, id },
});
export const duplicateViewDataError = error => ({
  type: DUPLICATE_VIEW_DATA_ERROR,
  payload: { error },
});

actions[DUPLICATE_VIEW_DATA_REQUEST] = state => ({ ...state,
});
actions[DUPLICATE_VIEW_DATA_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  trackings: payload.tracking,
  leagueId: payload.id,
});
actions[DUPLICATE_VIEW_DATA_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadDuplicateCustomLeagueData = () => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(duplicateViewDataRequest());
    const [{ tracking }] = await Promise.all([
      api.tracking.getAll(),
      dispatch(loadFormulaOptions),
      dispatch(loadFormulas),
      dispatch(getTracking),
    ]);

    const state = getState();
    const { id } = selectParams(state);

    dispatch(prepareTabbingIndex(state.formulas.options));

    dispatch(fetchLeagueTracking(tracking, id));

    // Create a ready-to-save API-formatted object with the selected League's tracking data
    const updatedTracking = [];
    if (tracking && tracking.length) {
      const selectedLeagueTracking = filter(tracking, ({ formulas }) =>
        filter(formulas, ({ formula_id }) => formula_id === id).length ? true : false);

      if (selectedLeagueTracking.length) {
        selectedLeagueTracking.forEach(({ player_id, formulas }) => {
          updatedTracking.push({
            player_id,
            formula_ids: [id],
          });
        });
      }
    }
    dispatch(changeUpdatedTrackingAction(updatedTracking));

    const name = selectFormula(state, id).name + ' Copy';
    dispatch(duplicateLeague(id, name));

    dispatch(duplicateViewDataSuccess({ tracking, id }));
  } catch (error) {
    console.error(error);
    dispatch(duplicateViewDataError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// Route / View
// ------------------------------------
export const CUSTOM_LEAGUE_VIEW = `${STORE_KEY}/view/CUSTOM`;
viewNames[CUSTOM_LEAGUE_VIEW] = 'myhuddle/Custom';
routes[CUSTOM_LEAGUE_VIEW] = {
  path: '/myhuddle/custom',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    if (!loggedIn) dispatch(redirect({ type: GO_LOGIN }));
    else {
      const { status } = getState().auth.user;
      if (status === 'C') dispatch(redirect({ type: RENEW_SUBSCRIPTION_VIEW }));
        else {
          await dispatch(loadCustomLeagueData());
          await dispatch(loadToolDescriptions());
        }
    }

  },
};

export const CUSTOM_LEAGUE_CREATE_VIEW = `${STORE_KEY}/view/CREATE`;
viewNames[CUSTOM_LEAGUE_CREATE_VIEW] = 'myhuddle/CustomCreate';
routes[CUSTOM_LEAGUE_CREATE_VIEW] = {
  path: '/myhuddle/custom/create',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    if (!loggedIn) dispatch(redirect({ type: GO_LOGIN }));
    else {
      const { status } = getState().auth.user;
      if (status === 'C') dispatch(redirect({ type: RENEW_SUBSCRIPTION_VIEW }));
      else await dispatch(loadCreateCustomLeagueData());
    }
  },
};

export const CUSTOM_LEAGUE_EDIT_VIEW = `${STORE_KEY}/view/EDIT`;
viewNames[CUSTOM_LEAGUE_EDIT_VIEW] = 'myhuddle/CustomEdit';
routes[CUSTOM_LEAGUE_EDIT_VIEW] = {
  path: '/myhuddle/custom/edit/:id',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    if (!loggedIn) dispatch(redirect({ type: GO_LOGIN }));
    else {
      const { status } = getState().auth.user;
      if (status === 'C') dispatch(redirect({ type: RENEW_SUBSCRIPTION_VIEW }));
      else await dispatch(loadEditCustomLeagueData());
    }
  },
};

export const CUSTOM_LEAGUE_DUPLICATE_VIEW = `${STORE_KEY}/view/DUPLICATE`;
viewNames[CUSTOM_LEAGUE_DUPLICATE_VIEW] = 'myhuddle/CustomDuplicate';
routes[CUSTOM_LEAGUE_DUPLICATE_VIEW] = {
  path: '/myhuddle/custom/copy/:id',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    if (!loggedIn) dispatch(redirect({ type: GO_LOGIN }));
    else {
      const { status } = getState().auth.user;
      if (status === 'C') dispatch(redirect({ type: RENEW_SUBSCRIPTION_VIEW }));
      else await dispatch(loadDuplicateCustomLeagueData());
    }
  },
};

export const LEAGUE_DETAILS_VIEW = `${STORE_KEY}/view/LEAGUE_DETAILS`;
viewNames[LEAGUE_DETAILS_VIEW] = 'myhuddle/LeagueDetails';
routes[LEAGUE_DETAILS_VIEW] = {
  path: '/myhuddle/league-details/:id',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    if (!loggedIn) dispatch(redirect({ type: GO_LOGIN }));
    else {
      const { status } = getState().auth.user;
      if (status === 'C') dispatch(redirect({ type: RENEW_SUBSCRIPTION_VIEW }));
      else await dispatch(loadEditCustomLeagueData());
    }
  },
};

// ------------------------------------
// sort the QB, K, OF, DF stats the way they want instead of the way they come back
// ------------------------------------

export const renderStatName = (name, title) => {
  if(name === 'Yardage Bonus' && title === 'QUARTERBACK') {
    return '300 yard Bonus';
  }
  else if(name === 'Yardage Bonus' && title.search('RUNNING BACK')) {
    return '100 yard Bonus';
  }
  else if(name === 'Interceptions Thrown' && title === 'QUARTERBACK') {
    return 'INT Thrown';
  }
  else if(name === 'Pass Interceptions' && title === 'IDP') {
    return 'Interceptions';
  }
  else if(name === 'Passing Touchdowns') {
    return 'Passing TDs';
  }
  else if(name === 'Receiving Touchdowns') {
    return 'Receiving TDs';
  }
  else if(name === 'Rushing Touchdowns') {
    return 'Rushing TDs';
  }
  else {
    return name;
  }
};

export const arrangeQBStats = (stats) => {
  if(!stats.find(stat => (stat.stat_name) === '50+ yard TD bonus')) {
    return stats;
  }
  var ret=[];
  ret[0]=stats.find(stat => (stat.stat_name) === 'Passing Yards');
  ret[1]=stats.find(stat => (stat.stat_name) === 'Passing Touchdowns');
  ret[2]=stats.find(stat => (stat.stat_name) === 'Interceptions Thrown');
  ret[3]=stats.find(stat => (stat.stat_name) === 'Rushing Yards');
  ret[4]=stats.find(stat => (stat.stat_name) === 'Rushing Touchdowns');
  ret[5]=stats.find(stat => (stat.stat_name) === 'Yardage Bonus');
  ret[6]=stats.find(stat => (stat.stat_name) === '50+ yard TD bonus');
  return ret;
};

export const arrangeOFStats = (stats) => {
  if(!stats.find(stat => (stat.stat_name) === '50+ yard TD bonus')) {
    return stats;
  }
  var ret=[];
  ret[0]=stats.find(stat => (stat.stat_name) === 'Rushing Yards');
  ret[1]=stats.find(stat => (stat.stat_name) === 'Rushing Touchdowns');
  ret[2]=stats.find(stat => (stat.stat_name) === 'Receptions');
  ret[3]=stats.find(stat => (stat.stat_name) === 'Receiving Yards');
  ret[4]=stats.find(stat => (stat.stat_name) === 'Receiving Touchdowns');
  ret[5]=stats.find(stat => (stat.stat_name) === 'Yardage Bonus');
  ret[6]=stats.find(stat => (stat.stat_name) === '50+ yard TD bonus');
  return ret;
};

export const arrangeKStats = (stats) => {
  if(!stats.find(stat => (stat.stat_name) === 'Extra Points Missed')) {
    return stats;
  }
  var ret=[];
  ret[0]=stats.find(stat => (stat.stat_name) === 'Field Goals Made');
  ret[1]=stats.find(stat => (stat.stat_name) === 'Field Goals Missed');
  ret[2]=stats.find(stat => (stat.stat_name) === 'Extra Points Made');
  ret[3]=stats.find(stat => (stat.stat_name) === 'Extra Points Missed');
  return ret;
};

export const arrangeIDPStats = (stats) => {
  if(!stats.find(stat => (stat.stat_name) === 'Tackles')) {
    return stats;
  }
  var ret=[];
  ret[0]=stats.find(stat => (stat.stat_name) === 'Tackles');
  ret[1]=stats.find(stat => (stat.stat_name) === 'Assists');
  ret[2]=stats.find(stat => (stat.stat_name) === 'Sacks');
  ret[3]=stats.find(stat => (stat.stat_name) === 'Forced Fumbles');
  ret[4]=stats.find(stat => (stat.stat_name) === 'Fumble Recoveries');
  ret[5]=stats.find(stat => (stat.stat_name) === 'Pass Interceptions');
  ret[6]=stats.find(stat => (stat.stat_name) === 'Pass Defensed');
  return ret;
};

export const arrangeDFStats = (stats) => {
  if(!stats.find(stat => (stat.stat_name) === 'Sacks')) {
    return stats;
  }
  var ret=[];
  /* Kickoff Return is used for both PR and KO TDs */
  ret[0]=stats.find(stat => (stat.stat_name) === 'DT Return TDs');
  ret[1]=stats.find(stat => (stat.stat_name) === 'KO or PR TDs');
  ret[2]=stats.find(stat => (stat.stat_name) === 'Sacks');
  ret[3]=stats.find(stat => (stat.stat_name) === 'Fumble Recoveries');
  ret[4]=stats.find(stat => (stat.stat_name) === 'Interceptions');
  ret[5]=stats.find(stat => (stat.stat_name) === 'Safeties');
  return ret;
};

export const arrangeSTStats = (stats) => {
  if(!stats.find(stat => (stat.stat_name) === 'Return Yards')) {
    return stats;
  }
  var ret=[];
  /* Kickoff Return is used for both PR and KO TDs */
  ret[0]=stats.find(stat => (stat.stat_name) === 'Return Yards');
  ret[1]=stats.find(stat => (stat.stat_name) === 'Return TDs');
  return ret;
};



// WEBPACK FOOTER //
// ./src/app/views/Custom/module/custom.js